export const homeObjOne = {
  id: "about",
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: "Webilo Websites",
  headline: "A Mint of Creativity.",
  description:
    "Get a top-notch website for your business to improve your brand awareness and sales. No humans will surf in an average look website for them. Make business in a modern way.",
  buttonLabel: "Get a free quote",
  imgStart: false,
  img: require("../../images/webilo-about.svg").default,
  alt: "About Webilo",
  dark: true,
  primary: true,
  darkText: false,
};

export const homeObjTwo = {
  id: "discover",
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: "Webilo Softwares",
  headline: "Precise Solutions for your Business.",
  description:
    "Webilo offers diffrent kind of cross-platform softwares for all scale of businesses needs.",
  buttonLabel: "Get Started",
  imgStart: true,
  img: require("../../images/webilo-services.svg").default,
  alt: "Webilo Softwares",
  dark: false,
  primary: false,
  darkText: true,
};

export const homeObjThree = {
  id: "contact",
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: "Webilo Connect",
  headline: "24/7 Mail us. Let's talk.",
  description:
    "We have a good customer service relationship with our clients from the beginning. And we are thrivig to maintain that.",
  buttonLabel: "Mail us.",
  imgStart: false,
  img: require("../../images/webilo-contact.svg").default,
  alt: "Contact for more",
  dark: false,
  primary: false,
  darkText: true,
};
